// extracted by mini-css-extract-plugin
export default {"Facebook":"J8Sftp9","Instagram":"mbXMayF","Snapchat":"CDRgBJC","Vk":"ZNHON6r"};